import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../shared/models';
import { ShowHideInput } from '../shared'
import { Errors, UserService } from '../shared';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forgotpwd',
  templateUrl: './forgotpwd.component.html',
  styleUrls: ['./forgotpwd.component.css']
})
export class ForgotpwdComponent implements OnInit {
  code: any;
  authType: string = '';
  title: string = '';
  ff: string = '';
  public fors: any = {}
  errors: Errors = new Errors();
  isSubmitting = false;
  authForm: FormGroup;
  pattern: string;
  type: string = 'email';
  @ViewChild(ShowHideInput) input: ShowHideInput;
  show = false;
  setmask: any = ''
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private fb: FormBuilder,
    private toast: ToastrService,
    private translate: TranslateService
  ) {
    // use FormBuilder to create a form group
    this.authForm = this.fb.group({
      'email': ['', Validators.required],
      'code': ['1']
    });
    this.translate.setDefaultLang(userService.defaultLang); 
  }

  ngOnInit() {

  }
  toggleShow() {
    this.show = !this.show;
    //////console.log(this.input); //undefined
    if (this.show) {
      this.input.changeType("text");
    }
    else {
      this.input.changeType("password");
    }
  }
  setAuth(user: User) {
    if (user.item.appRoles == "PRACTICE" || user.item.appRoles == "HOSPITAL") {
      this.router.navigateByUrl('/cc/dashboard')
    }
    else if (user.item.appRoles == "PATIENT") {
      this.router.navigateByUrl('/pp/dashboard')
    }
    else if (user.item.appRoles == "SOLVEDGE") {
      this.router.navigateByUrl('/admin/dashboard')
    }
  }
  // sendmail() {
  //   this.isSubmitting = true;
  //   this.errors = new Errors();

  //   const credentials = this.authForm.value;
  //   this.userService
  //   .attemptAuth(credentials)
  //   .subscribe(
  //     data => this.router.navigateByUrl('/changepassword/:value'),
  //     err => {
  //       this.errors = err;
  //       this.isSubmitting = false;

  //     }
  //   ); 

  // }







  sendmail(s) {
    this.ff = "";
    //////console.log(s.value);
    if (s.value.code) {
      s.value.email = s.value.code + '-' + s.value.email
    }

    if(sessionStorage.getItem("langChangedByUser") == "true"){
      this.userService.langChangedByUser = false;
      this.forgotPwdChecking(s);
      sessionStorage.removeItem("langChangedByUser")
    }
    else {
      this.getPreferredLanguage(s.value.email, s);
    }
  }

  getPreferredLanguage(email, s) {
		const credential = {
      'userName': email
    }
    this.userService.getLanguageConfig(credential).subscribe(
      langConfigRes => {
        if(langConfigRes && langConfigRes.hasOwnProperty("multiLanguageRequired")) {
          if(langConfigRes?.multiLanguageRequired) {
            this.userService.setCurrentLanguage(langConfigRes?.preferredlanguage)
          }
        }

        setTimeout(() => {
          this.forgotPwdChecking(s);
        }, 200)
    });
  }

  forgotPwdChecking(s: any) {
    this.userService.fgotdetails(s.value.email)
      .subscribe(
        data => {
          if (data.item.status === "success") {
        }
        if (data.item.status != "success") {
          this.toast.error(data.item.message)
          s.resetForm();
        } else if (data.item.AvailSecurity) {
          this.userService.setmail(s.value.email)
        } else if (data.item.status1 == 'showingQueNAns') {
          this.userService.setmail(s.value.email)
          this.userService.forgotUserInfo(s.value.email)
            .subscribe(
              data1 => {
                window.localStorage['status'] = 'forgotlink'
                window.localStorage['randId'] = data.item.randId
                if (data1.userGroupId != 19 && data1.userGroupId != 20 && data1.allowPasswordChange)
                  this.router.navigateByUrl('/securityquestion');
                else
                  this.router.navigateByUrl('/security');

              })
          s.resetForm();
        } else if (data.item.status == 'success') {
            this.toast.info(data.item.message)
          this.userService.setmail(s.value.email)
          s.resetForm();
          this.userService.setDefaultLanugage = false; //to prevent screen changed into spanish into English in Login
          this.router.navigateByUrl('/login');

        } else {
          this.ff = "";
          }

        }
      );
  }

  public customPatterns = { 'A': { pattern: new RegExp('\[a-zA-Z0-9._@+-\]') }, '0': { pattern: new RegExp('\[0-9\]') } };
  Onchange(event) {
    if (event.keyCode != 8) {
      let targetvalue = event.target.value.replace(/[^a-zA-Z0-9._@+]/g, '');
      let keyvalue = event.key.replace(/[^a-zA-Z0-9._@+]/g, '');
      if (isNaN(targetvalue) || targetvalue == '' || isNaN(keyvalue) || keyvalue == '') {
        this.setmask = "A*"
        this.type = 'email'
      } else
        this.type = 'number'
    }
    else {
      if (event.target.value.length <= 0) {
        this.type = 'email'
        this.setmask = "A*"
      }
    }
    if (this.type == 'email')
      this.fors.code = undefined
    else {
      if (this.fors.code == '1' || this.fors.code == undefined || this.fors.code == null) {
        this.fors.code = '1'
        this.checkphone('1')
      }
      else {
        this.checkphone(this.fors.code)
      }
    }

  }
  checkphone(code) {
    if (this.type == 'number') {
      if (code == '44') {
        this.setmask = '00000 000000'
      } else {
        this.setmask = '(000) 000-0000'
      }
    }

  }
  getFullYear() {
    return new Date().getFullYear();
  }
  setvalue() {
    if (this.type != 'number') {
      return false
    } {
      return true
    }
  }

}
